import { render } from "./Screensaver.vue?vue&type=template&id=7a9da825"
import script from "./Screensaver.vue?vue&type=script&lang=js"
export * from "./Screensaver.vue?vue&type=script&lang=js"

import "./Screensaver.vue?vue&type=style&index=0&id=7a9da825&lang=scss"

import exportComponent from "E:\\code\\libra-3rd\\yuexinting-jiading\\yxt-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__